/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import { Box } from '../../';
import SkeletonBox from './SkeletonBox';
import useRandomSkeletonWidth from './useRandomSkeletonWidth';
/**
 * @param {object} props
 * @param {number} [props.offset] The offset for a staggered animation.
 * @param {string | number} [props.width]
 * @param {string} [props.variant] The label variant, defined in labelVariants.js.
 * @param {string} [props.className]
 */
export default function SkeletonLabel({ width, offset = 0, variant = 'default', className, }) {
    const [getWidth] = useRandomSkeletonWidth(1, { width });
    return (jsx(Box, { className: className },
        jsx(SkeletonBox, { as: "p", offset: offset, width: getWidth(0), sx: {
                variant: `label.${variant}`,
                transform: 'scaleY(0.7)',
            } })));
}
//# sourceMappingURL=SkeletonLabel.js.map